
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/presentacio-projectes-3cat",
      function () {
        return require("private-next-pages/corporatiu/presentacio-projectes-3cat/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/presentacio-projectes-3cat"])
      });
    }
  